import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {TemplateTag as Entity} from "./template-tag.model";
import {IPageInfo, IResultWithPageInfo, ITableSort} from "../app-store.interfaces";

export interface TemplateTagState extends EntityState<Entity> {
  entities: { [id: number]: Entity };
  ids: number[];
  isLoading: boolean;
  error: Error | undefined;
  currentPage: IPageInfo;
  currentSort: ITableSort | undefined;
  currentEntityId: number | undefined,
  templateTagValues: { [templateCategoryId: number]: Entity[] } | undefined;
  history: { correlationId: string, payload: Entity | Entity[] | number | number[] | IResultWithPageInfo<Entity> }[];
}

export const templateTagEntityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>({
    selectId: (product: Entity) => product.id
});

export const initialState: TemplateTagState = templateTagEntityAdapter.getInitialState({
  entities: [],
  ids: [],
  isLoading: false,
  error: undefined,
  currentPage: { page: { pageNumber: 0, pageSize: 25 }, totalCount: 0},
  currentSort: undefined,
  currentEntityId: undefined,
  templateTagValues: undefined,
  history: []
});
